<template>
	<optgroup>
		<option value="string">String</option>
		<option value="slug">Slug</option>
		<option value="tags">Tags</option>
		<option value="wysiwyg">WYSIWYG</option>
		<option value="textarea">Textarea</option>
		<option value="status">Status</option>
		<option value="date">Date</option>
		<option value="photo">Photo</option>
		<option value="photo_gallery">Photo Gallery</option>
		<option value="file_gallery">File Gallery</option>
		<option value="file">File</option>
		<option value="associated_module">Associated Module</option>
		<option value="static">Static Text</option>
		<option value="super_string">Super-Only String</option>
		<option value="super_dropdown">Super-Defined Dropdown</option>
		<option value="current_gps">Current GPS Location</option>
		<option value="numeric">Numeric</option>
	</optgroup>
</template>

<script>

export default {

	props: {
		curated: Boolean,
	},

};

</script>
